import { render, staticRenderFns } from "./SwitchCheckbox.vue?vue&type=template&id=7881b998&scoped=true&"
import script from "./SwitchCheckbox.vue?vue&type=script&lang=js&"
export * from "./SwitchCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./SwitchCheckbox.vue?vue&type=style&index=0&id=7881b998&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7881b998",
  null
  
)

export default component.exports